<template>
    <div class="confirmation-order">
        <b-container>
            <b-row>
                <router-link :to="{ name: 'FormPage'}" class="btn-back"> Inicio</router-link>
                <b-col cols="12" class="mb-5">
                    <h3 class="mb-4"><img class="icon" src="../../assets/imgs/icn_confirmation.svg" alt=""> Confirmación de orden</h3>   
                    <p>Se ha enviado la información de tu orden. Aquí puedes ver los detalles de tu orden.</p>
                </b-col>
                <b-col cols="12" class="mb-3">
                    <h3><img class="icon" src="../../assets/imgs/icn_orderdetails.svg" alt=""> Detalles de tu orden</h3>   
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Hospital</span>
                    <p>{{data.hospital.name}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Sub Configuración de Puesto</span>
                    <p>{{data.area.name}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Puesto</span>
                    <p>{{data.position.name}}</p>
                </b-col>
                <!-- <b-col v-if="data.area.name =='Dirección Médica' || data.area.name=='7 Dirección Médica DAMA' || data.area.name=='8 Dirección Médica CABALLERO' "  md="4" class="mb-4">
                    <span>Especialidad</span>
                    <p>{{data.speciality}}</p>
                </b-col> -->
                <!-- <b-col v-if="data.area.name =='Dirección Médica' || data.area.name=='7 Dirección Médica DAMA' || data.area.name=='8 Dirección Médica CABALLERO' " md="4" class="mb-4">
                    <span>Bordado</span>
                    <p>{{data.embroid}}</p>
                </b-col> -->
            </b-row>
            <b-row>
                <b-col class="mb-5" cols="12">
                     <table class="table b-table">
                        <thead role="rowgroup">
                            <tr>
                                <th>
                                    Uniforme
                                </th>
                                <th>
                                    Modelo
                                </th>
                                <th>
                                    Género
                                </th>
                                <th>
                                    Talla
                                </th>
                            </tr>
                        </thead>
                        <tbody role="rowgroup">
                            <tr role="row" v-if="data.scrub_qty!=0 && data.scrub_model">
                                <td>
                                    Coordinado Filipina
                                </td>
                                <td>Modelo {{data.scrub_model}}</td>
                                <td class="text-center">{{data.gender.name}}</td>
                                <td class="text-center">{{data.scrub_size}}</td>
                            </tr>
                            <tr role="row" v-if="data.pants_qty!=0 && data.pants_model">
                                <td>
                                    Coordinado Pantalón
                                </td>
                                <td>Modelo {{data.pants_model}}</td>
                                <td class="text-center">{{data.gender.name}}</td>
                                <td class="text-center">{{data.pants_size}}</td>
                            </tr>
                            <tr role="row" v-if="data.coat_qty!=0 && data.coat_model">
                                <td>
                                    Bata
                                </td>
                                <td>Modelo {{data.coat_model}}</td>
                                <td class="text-center">{{data.gender.name}}</td>
                                <td class="text-center">{{data.coat_size}}</td>
                            </tr>
                            <tr role="row" v-if="data.coat_qty2!=0 && data.coat_model2">
                                <td>
                                    Bata
                                </td>
                                <td>Modelo {{data.coat_model2}}</td>
                                <td class="text-center">{{data.gender.name}}</td>
                                <td class="text-center">{{data.coat_size2}}</td>
                            </tr>
                            <tr role="row" v-if="data.scrub_cap_qty!=0 && data.scrub_cap_model">
                                <td>
                                    Chamarras
                                </td>
                                <td>Modelo {{data.scrub_cap_model}}</td>
                                <td class="text-center">{{data.gender.name}}</td>
                                <td class="text-center">{{data.scrub_cap_size}}</td>
                            </tr>
                            <tr role="row" v-if="data.overol_qty!=0 && data.overol_model">
                                <td>
                                    Overol
                                </td>
                                <td>Modelo {{data.overol_model}}</td>
                                <td class="text-center">{{data.gender.name}}</td>
                                <td class="text-center">{{data.overol_size}}</td>
                            </tr>
                            <tr role="row" v-if="data.shoes_qty!=0 && data.shoes_model">
                                <td>
                                    Calzado
                                </td>
                                <td>Modelo {{data.shoes_model}}</td>
                                <td class="text-center">{{data.gender.name}}</td>
                                <td class="text-center">{{data.shoes_size}}</td>
                            </tr>
                        </tbody>
                     </table>
                </b-col>
                <b-col cols="4">
                    <b-button v-on:click="logOut" class="btn">Cerrar sesión</b-button>
                </b-col>
                <b-col cols="4">
                    <router-link :to="{ name: 'FormPage'}" class="btn">Nuevo registro</router-link>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: Array,
                required: true
            },
        },
        methods: {
            logOut(){
                sessionStorage.removeItem('dataOrder')
                this.$router.push({ name: 'login'})
            }
        },
        created() {
            var datalist = sessionStorage.getItem('dataOrder');
            if (!this.data) {
                this.data = JSON.parse(datalist)
            }
            if (!this.data){
                this.$router.push('/orden')
            }
        },
        destroyed() {
            sessionStorage.removeItem('dataOrder')
        },
        data() {
            return {
            }
        }
    }
</script>

<style scoped>
.confirmation-order{
    padding: 70px 15%;
}

h3{
    font-weight: bold;
    font-size: 25px;
}
span{
    font-size: 16px;
    color: #5965B1;
}
p,
p > span{
   font-size: 20px; 
}

.btn,
.btn:focus,
.btn:hover{
    background: #F15E1A !important;
    border: none;
    color: #fff !important;
    width: 100%;
}
.icon{
    margin-top: -5px;
    margin-right: 10px;
}
.btn-back{
    position: absolute;
    left: 10%;
    text-decoration: none;
    color: #5965B1;
    border: 1px solid #5965B1;
    width: fit-content;
    padding: 5px 20px;
    border-radius: 5px;
}
@media (max-width: 1600px) {
    .confirmation-order{
        padding: 50px 15%;
    }
    .confirmation-order .container{
        padding: 0 11%;
    }
    h3{
        font-size: 18px;
    }
    span{
        font-size: 12px;
    }
    p,
    p > span{
        font-size: 15px; 
    }
    .note{
        font-size: 11px;
    }
    .icon{
        width: 20px;
        margin-right: 5px;
    }
}
@media (max-width: 768px) {
    .confirmation-order .container{
        padding: 0;
    }
    .btn-back{
        position: relative;
        left: 0;
        margin-bottom: 20px;
    }
}
</style>